<template>
  <div class="col-lg-6 col-xl-4">
    <div class="portlet portlet--project">
      <div class="portlet-head align-items-center d-flex justify-content-between">
        <h3>Dokumenty</h3>
      </div>
      <div class="portlet-body">
        <div
          class="project-document"
          v-for="(item,index) in availableFileCategory"
          :key="index"
          @click="showModal(item)"
        >
          <div :id="item.ico"></div>
          <span>{{name[item.name]}}</span>
          <div class="col-2 d-flex justify-content-center">
            <template v-if="files[item.id]">{{files[item.id].length}}</template>
            <template v-else>0</template>
          </div>
        </div>
      </div>
    </div>
    <FilesModal
      :files="selected_files"
      :category="selected_category"
      :construction_id="construction_id"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilesModal from "@/components/files/FilesModal";

export default {
  name: "FilesPortlet",
  components: { FilesModal },
  props: {
    construction_id: { type: Number }
  },
  data() {
    return {
      selected_files: [],
      selected_category: {
        id: 0,
        name: ""
      },
      name: {
        measurements: "Pomiary mieszkania",
        protocols: "Protokoły",
        sealing: " Uszczelnianie alternatywne przed kafelkowaniem",
        pickup_after_renovation: "Odbiór po remoncie",
        defects: "Usterki",
        sketches: "Szkic mieszkania",
        documents: "Dokumenty",
        inprogress: "W trakcie realizacji",
        offers: "Oferty"
      }
    };
  },
  computed: {
    ...mapGetters("app", ["availableFileCategory"]),
    ...mapGetters("construction", ["files"])
  },
  created() {},
  methods: {
    showModal(category) {
      if(!this.files[category.id]){
        this.$store.commit('construction/filesCreateCategory', category.id);
      }
      this.selected_files = this.files[category.id];
      this.selected_category = {
        id: category.id,
        name: this.name[category.name]
      };

      this.$nextTick(() => {
        this.$bvModal.show("files-modal");
      });
    }
  }
};
</script>